export default {
	storeGetterCommon(val, type) {
		if (type === 'object') {
			if (Object.keys(val).length) return val
			return null
		}
		if (type === 'array') {
			if (val.length) return val
			return null
		}
		return val
	},
	storeGetterLocalCommon(state, key, type = '') {
		const temp = this.storeGetterCommon(state[key], type)
		if (temp) return temp
		let data = window.localStorage.getItem(key)
		if (['object', 'array'].includes(type)) data = JSON.parse(data)
		return data
	},
	storeGetterSessionCommon(state, key, type = '') {
		const temp = this.storeGetterCommon(state[key], type)
		if (temp) return temp
		let data = window.sessionStorage.getItem(key)
		if (['object', 'array'].includes(type)) data = JSON.parse(data)
		return data
	}
}
